<template>
  <b-dropdown
    :toggle-class="toggleClass"
    menu-class="menu-shadow"
    id="dropdown-left"
    variant="default"
    class="m-0"
    :lazy="true"
    no-caret
  >
    <template v-slot:button-content>
      <div class="selected-status">
        <span :id="'status-' + initiative.id" class="d-flex">
          <i :class="getStatus(status).icon"></i>
        </span>
        <tooltip :target="'status-' + initiative.id">{{ getStatus(status).label }}</tooltip>
      </div>
    </template>
    <b-dropdown-item
      v-for="(status, index) in statusOptions"
      @click="$emit('change', { status: status.id })"
      :key="index"
      ><div class="d-flex align-items-center">
        <i :class="status.icon"></i>
        <span class="ml-2 text-prime text-medium-1">{{ status.label }}</span>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import * as R from 'ramda'
import Tooltip from '@/components/Tooltip'
import { STATUS_OPTIONS } from '@/constants/initiative'

/**
 * This component serves the purpose of status cell in initiative row. This also provides ability to change initiative status
 */
export default {
  name: 'StatusField',
  props: ['initiative'],
  computed: {
    status() {
      return this.initiative.status
    },
    toggleClass() {
      return `dropdown-field d-flex justify-content-center border-0 status-${
        this.initiative.status
      }`
    }
  },
  data() {
    return {
      statusOptions: STATUS_OPTIONS
    }
  },
  components: {
    BDropdown,
    BDropdownItem,
    Tooltip
  },
  methods: {
    getStatus(statusId) {
      return this.statusOptions.find(R.propEq('id', statusId))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
@import '~@/styles/variables/_initiativeStatus.scss';

.clock-grey-icon {
  @include dimension(16px, 16px);
}
/deep/ {
  .status-not-started {
    background-color: $initiativeStatus_notStarted !important;
  }
  .status-on-track {
    background-color: $initiativeStatus_onTrack !important;
  }
  .status-behind {
    background-color: $initiativeStatus_behind !important;
  }
  .status-at-risk {
    background-color: $initiativeStatus_atRisk !important;
  }
  .status-done {
    background-color: $initiativeStatus_done !important;
  }
}
</style>
